import { ReactComponent as SMSIcon } from 'assets/icons/messages/sms.svg';

export const messages = {
  sms: SMSIcon,
};
